var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.941,
    height: 24.951,
    viewBox: "0 0 29.941 24.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1725.275 -33.563)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1725.275 33.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.485,19.466a.934.934,0,0,1-.676-.289L6.26,12.315a.936.936,0,0,1,.676-1.582h3.431V3.559A1.562,1.562,0,0,1,11.926,2h3.119A1.562,1.562,0,0,1,16.6,3.559v7.173h3.431a.936.936,0,0,1,.676,1.582l-6.55,6.861A.934.934,0,0,1,13.485,19.466Z",
    transform: "translate(1.485 -2)",
    fill: "#112c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.758,21.868H2.183A1.988,1.988,0,0,1,0,20.176v-.484A1.988,1.988,0,0,1,2.183,18H27.758a1.988,1.988,0,0,1,2.183,1.692v.484A1.988,1.988,0,0,1,27.758,21.868Z",
    transform: "translate(0 3.083)",
    fill: "#112c5a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloads);
export default __webpack_public_path__ + "static/media/downloads.addfa6d08f61ca28a8bdb7aabf45090c.svg";
export { ForwardRef as ReactComponent };